import { useEffect, useState } from 'react';
import IVenue from "../../../yoello-lib/modules/API/interfaces/IVenue";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useDispatch } from 'react-redux';
import { setSelectedVenue } from '../../../actions/venue';
import { setSubscription } from '../../../actions/subscriptions';
import { setIsEposNow } from '../../../actions/isEposNow';
import { useVenueSelection } from '../../../hooks/useVenueSelection';
import { HTTPMethods } from '../../../yoello-lib/modules/API/API';
import { IMerchantAccount } from '../../../interfaces/IMerchantAccount';
import { setVenuePermissions } from '../../../yoello-lib/modules/redux/actions/venue.actions';

/**Gets users venues and if there is selected if no selected venue and greater tha */
const useGetSelectedVenue = (merchant: IMerchantAccount , isMerchantLoading:boolean) => {
    const { isError, callAPI } = useAPIV2<IVenue[] | IVenue>(APIExtensions.venues, { onMountDisabled: true, params: { include_disabled: true, size:10 }  });
    const [selectedVenue, _setSelectedVenue] = useState<IVenue | null>();
    const [hasVenues, setHasVenues] = useState<boolean>(true);
    const [isVenueSettingUp, setIsVenueSettingUp] = useState<boolean>(false);
    const dispatch = useDispatch();
    const selectVenue = useVenueSelection();

    useEffect(() => {
        const selectedVenueId = localStorage.getItem('selected-venue-id');
        async function setupVenue(){
            setIsVenueSettingUp(true);
            const venues = await callAPI(HTTPMethods.GET);
            if(venues.isSuccessful && venues.data){
                if(venues.data.length === 0){
                    setHasVenues(false);
                }else{
                    if(selectedVenueId){
                        try {
                            const response = await callAPI(HTTPMethods.GET, {
                                query: selectedVenueId
                            });
                            if (!response || !response.data) throw Error;
                            if(response.isSuccessful && !isError){
                                if(response.data){
                                    if(typeof response.data === 'object'){ 
                                        const venueData = response.data as IVenue;
                                        settingUp(venueData)
                                    }  
                                }
                            }else{
                                checkError(response.data , selectedVenueId!)
                            }
                        } catch (error) {
                            setHasVenues(false)
                        }
                    }else{
                        _setSelectedVenue(null)
                    }
                }
            }
            
    
            setIsVenueSettingUp(false)
        }
        if (merchant?.id && !selectedVenue && !isMerchantLoading) {
            setupVenue();
        }
        // eslint-disable-next-line
    }, [merchant, selectedVenue, isMerchantLoading]);
    


    function settingUp(venueData: IVenue) {
        const permissionsObj = {};

        if (venueData?.eposnow_company_id) {
            dispatch(setSubscription("EPOSNOW"));
            dispatch(setIsEposNow(true));
        } else if (venueData?.payment_processor === 'SQUARE') {
            dispatch(setSubscription("SQUARE"));
            dispatch(setIsEposNow(false));
        } else {
            dispatch(setSubscription("YOELLO"));
            dispatch(setIsEposNow(false));
        }
        venueData.user_permissions?.forEach((permission: { permission_set: string, value: boolean }) => {
            //@ts-ignore
            permissionsObj[permission.permission_set] = permission.value;
        })
        dispatch(setVenuePermissions(permissionsObj));
        dispatch(setSelectedVenue(venueData.id!));
        _setSelectedVenue(venueData);
    }

    function checkError(response:any , venueId:String){
        const errorResponse = response?.response?.data?.data;
        if (errorResponse && Array.isArray(errorResponse)) {
            if (errorResponse[0].code === "ACTION_FORBIDDEN" && 
            errorResponse[0].context.venue_id === venueId) {
                _setSelectedVenue(null);
                selectVenue(undefined)
            }
        }
    }

    return {
        isError,
        selectedVenue,
        hasVenues ,
        isVenueSettingUp,
        callAPI
    }
}

export default useGetSelectedVenue;